import React from 'react'
import { Space } from 'antd'
import { capitalize } from 'lodash'
import PatternIcon from '../../../../../../../components/common/PatternIcon'
import { getChangeType, extractIdFromField, normalizeFieldName } from '../utils/changeValueParser'

/**
 * Component for rendering the target of a change (what was changed)
 */
const ChangeTarget = ({ field, editingQuestion }) => {
    const changeType = getChangeType(field)

    // Handle booster-related changes
    if (changeType === 'booster_added') {
        return <span>added a tool</span>
    }

    if (changeType === 'booster_removed') {
        return <span>removed a tool</span>
    }

    if (changeType === 'booster_priority') {
        const boosterId = extractIdFromField(field, 'booster')
        return <span>changed tool #{boosterId} priority</span>
    }

    // Handle pattern/category creation
    if (changeType === 'pattern_created') {
        return <span>created a pattern</span>
    }

    // Handle conceptual label changes
    if (changeType === 'conceptual_label_added') {
        const patternId = extractIdFromField(field, 'pattern')
        const category = editingQuestion?.categories?.find(cat => cat.id === patternId)

        if (category) {
            return (
                <Space size={4}>
                    added conceptual label to
                    <PatternIcon id={patternId} colorId={category.colorId} content={category.grade} suffix='pt' />
                    {category.name}
                </Space>
            )
        }

        return <span>added conceptual label to pattern #{patternId}</span>
    }

    if (changeType === 'conceptual_label_removed') {
        const patternId = extractIdFromField(field, 'pattern')
        const category = editingQuestion?.categories?.find(cat => cat.id === patternId)

        if (category) {
            return (
                <Space size={4}>
                    removed conceptual label from
                    <PatternIcon id={patternId} colorId={category.colorId} content={category.grade} suffix='pt' />
                    {category.name}
                </Space>
            )
        }

        return <span>removed conceptual label from pattern #{patternId}</span>
    }

    // Handle category field changes (e.g., "2854_color_id")
    if (changeType === 'category_field' || changeType === 'category_color') {
        const categoryId = extractIdFromField(field, 'prefix')
        const category = editingQuestion?.categories?.find(cat => cat.id === categoryId)
        const fieldName = field.split('_').slice(1).join('_')

        if (category) {
            return (
                <Space size={4}>
                    changed
                    <PatternIcon id={categoryId} colorId={category.colorId} content={category.grade} suffix='pt' />
                    {category.name + "'s"}
                    {normalizeFieldName(fieldName)}
                </Space>
            )
        }

        return (
            <span>
                changed pattern #{categoryId} {normalizeFieldName(fieldName)}
            </span>
        )
    }

    // Default: just show the normalized field name
    return <span>changed {capitalize(normalizeFieldName(field))}</span>
}

export default ChangeTarget


